// extracted by css-extract-rspack-plugin
export default {"wrapper":"_87366630","letter":"_4259233d","divider":"_249d6ee2"};